module.exports = __webpack_public_path__ + "assets/img_invalid.11fbce0f.svg";